import { isSupportedLocation } from '@/modules/location/helpers';
import { useCurrentLocation } from '@/modules/location/useCurrentLocation';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function useListingCountry() {
  const { location } = useCurrentLocation();
  const [_, user] = useCurrentUser();
  const userCountry = user?.country || location;

  const normalisedUserCountry = userCountry.toLowerCase();
  const listingCountry = isSupportedLocation(normalisedUserCountry)
    ? normalisedUserCountry
    : location;

  return {
    // country resolution which always prefers user country over location
    userCountry,
    /* country resolution, which prefers user country only if it is ALSO a valid location
     * otherwise some functionality can unintentionally fall back to US, because user country does not exist as a valid
     * location in the system
     * */
    listingCountry,
  };
}
